<template>
  <b-modal
    :id="`manual-answer`"
    :title="`${$t('menu.sidebar.manualAnswer')} ${
      actionInfo.name ? 'para ' + actionInfo.name : ''
    }`"
    size="xl"
    hide-footer
  >

    <div class="make-call" v-if="userAuth && userAuth.ramalCode && actionInfo.phone">
      <span>Ramal: {{ userAuth.ramalCode }}</span>
      <b-button class="btn" variant="outline-info" @click="makeCall()">
        <i class="fas fa-phone-alt"></i>
        Ligar <b-spinner v-if="isLoadingCall" small></b-spinner>
      </b-button>
    </div>

    <div class="d-flex justify-content-center text-primary" v-if="loadingModal">
      <b-spinner type="grow"></b-spinner>
    </div>
    <div v-else-if="error" class="text-center">
      <p class="my-3">{{ error }}</p>
    </div>
    <div v-else>
      <iframe width="100%" style="position: absolute; height: 100%; top: 0; left: 0; border: none;" :src="`${baseUrl}/pesquisa/${actionInfo.token}/?c=M`"></iframe>
    </div>

  </b-modal>
</template>

<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import swal from 'sweetalert';
import api from '../../../services/api';

export default {

  props: ['position'],

  data: () => ({
    userAuth: null,
    baseUrl: window.location.origin,
    isLoadingCall: false
  }),

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  computed: {
    ...mapState('invites', ['actionInfo', 'myInvites']),
    ...mapFields('invites', ['loadingModal', 'error']),
  },

  methods: {
    makeCall() {
      this.isLoadingCall = true;
      const actionId = this.actionInfo.action._id;
      const phoneNumber = this.actionInfo.phone;
      const destination = '0' + phoneNumber.substring(2);

      api.post( `/phone-call/${actionId}/${destination}/${this.actionInfo._id}`, {}, 
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        }
      ).then(()=>{
        swal('Chamada efetuada com sucesso!', 'success');
      }).catch((error)=>{
        console.log(error);
        swal('Erro ao efetuar chamada!', 'error');
      }).finally(()=>{
        this.isLoadingCall = false;
      })
    }

  }

};
</script>

<style scoped>
.make-call {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 20px;
  position: absolute;
  top: -50px;
  right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/modal-manual-answer/index.vue